import { useApolloClient } from '@apollo/client';
import { merge } from 'lodash';
import { useContext } from 'react';
import { UtilityMachine } from '~/machines/utility-selection';
import { ContextSendMatch } from '~/machines/utils/types';
import { QueryParamsContext } from '~/providers/query-params/context';
import { handleProjectId } from '~/providers/query-params/handlers/handle-project-id';
import { DeepPartial } from '~/typings/utils';
import { SelectUtility, SelectUtilityProps } from './select-utility.component';

type SelectUtilityContainerProps = {
  micro: ContextSendMatch<UtilityMachine>;
  overrideCopy?: SelectUtilityProps['overrideCopy'];
  overrideProps?: DeepPartial<SelectUtilityProps>;
};

export const SelectUtilityContainer = ({
  micro: { context, send },
  overrideCopy,
  overrideProps,
}: SelectUtilityContainerProps) => {
  const apolloClient = useApolloClient();
  const { setValidatedProjectId, unparsedQueryParams } = useContext(QueryParamsContext);
  const props: SelectUtilityProps = {
    context: {
      utilityId: context.utilityId,
      zipCode: context.zipCode,
    },
    overrideCopy,
    next: async data => {
      const projectId = unparsedQueryParams?.projectId;
      if (projectId) {
        const validatedProjectId = await handleProjectId({
          apolloClient,
          projectId: projectId.toString(),
          utilityId: data.utilityId,
        });
        const parsedProjectId = !isNaN(Number(validatedProjectId))
          ? Number(validatedProjectId)
          : undefined;

        if (!parsedProjectId) {
          send({ type: 'INVALID_PROJECT_ID' });
        }
        if (setValidatedProjectId) {
          setValidatedProjectId(parsedProjectId);
        }
        send({ type: 'UPDATE_PROJECT_ID', funnelVnmProjectId: parsedProjectId });
      }
      send({ type: 'SUBMIT_UTILITY', data });
    },
  };

  return <SelectUtility {...merge(props, overrideProps)} />;
};
